import { api } from "@/lib/api";

export interface OpportunityStatsResponse {
  account_related_opportunity_count: number;
  account_related_opportunity_won_count: number;
  account_related_opportunity_open_count: number;
  contact_related_opportunity_count: number;
  contact_related_opportunity_won_count: number;
  contact_related_opportunity_open_count: number;
  total_opportunity_count: number;
  total_opportunity_won_count: number;
  total_opportunity_open_count: number;
}

/**
 * Hook for fetching comprehensive opportunity statistics for an account
 */
export function useAccountOpportunityStats(accountId?: string) {
  return api.useQuery<OpportunityStatsResponse>(
    `datahub/accounts/${accountId}/opportunity-stats/`,
    {
      enabled: !!accountId,
      // Cache the result for longer to avoid unnecessary refetches
      staleTime: 10 * 60 * 1000, // 10 minutes
    },
  );
}
